import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { convertImageUrl_S_to_M } from '~/backend/helper';
import wishlistIconActive from '~/images/wishlist-icon-active.svg';
import wishlistIcon from '~/images/wishlist-icon.svg';
import ProductCardCoupons from './ProductCardCoupons';

// Demo import

const ProductCardImage = ({ product, isFirst = false }) => {
	return (
		<div className="product-img">
			<Link to={product.eurl}>
				<img
					className="img"
					src={convertImageUrl_S_to_M(product.image)}
					alt={product.nm}
					loading={isFirst ? 'eager' : 'lazy'}
					fetchPriority={isFirst ? 'high' : 'auto'}
					decoding="async"
					width="218px"
					height="218px"
				/>
			</Link>
			<div className="wishlist-icon">
				<button type="button">
					<img
						className="active"
						src={!product.wishlistActive ? wishlistIcon : wishlistIconActive}
						onClick={() => product.handleWishlistToggle()}
						alt="wishlist icon"
					/>
				</button>
			</div>
			{product.cust_coupons && <ProductCardCoupons coupons={product.cust_coupons.filter(x => x.maxRedeemableItems > 0)} />}
		</div>
	);
};

ProductCardImage.propTypes = {
	product: PropTypes.object
};
export default ProductCardImage;
